// extracted by mini-css-extract-plugin
export default {"footer":"Check_footer__3uGNR","titleDesc":"Check_titleDesc__qA7QR","uploadExtra":"Check_uploadExtra__1HP9H"};